import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/api/client";
import { storeAuth, getStoredUser, isTokenExpired } from "@/lib/auth";
import WaypointLogo from "@/components/WaypointLogo";


export default function LoginPage() {
  const navigate = useNavigate();
  const btnRef = useRef<HTMLDivElement>(null);

  // Already logged in
  useEffect(() => {
    if (getStoredUser() && !isTokenExpired()) navigate("/");
  }, [navigate]);

  useEffect(() => {
    const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string;
    if (!clientId) return;

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.onload = () => {
      window.google?.accounts.id.initialize({
        client_id: clientId,
        callback: async ({ credential }) => {
          const { token, user } = await api.post<{
            token: string;
            user: { id: string; email: string; name: string };
          }>("/auth/google", { credential });
          storeAuth(token, user);
          navigate("/");
        },
      });
      if (btnRef.current) {
        window.google?.accounts.id.renderButton(btnRef.current, {
          type: "standard",
          theme: "filled_black",
          size: "large",
          width: 280,
        });
      }
    };
    document.body.appendChild(script);
    return () => script.remove();
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-zinc-950">
      <div className="flex flex-col items-center gap-3">
        <WaypointLogo className="h-14 w-14 text-brand" />
        <h1 className="text-2xl font-semibold text-zinc-50">Waypoint</h1>
        <p className="text-sm text-zinc-500">Track your progress</p>
      </div>
      <div ref={btnRef} />
    </div>
  );
}
